import { createAction } from 'signin-app/redux/helpers';
const domain = 'OTHER_CHILDREN';
export const { action: fetchGoHomeWithChildren, success: fetchGoHomeWithChildrenSuccess, failed: fetchGoHomeWithChildrenFailed, } = createAction(`${domain}/FETCH`, (childId) => ({ childId }), (response) => ({ response }));
export const { action: selectGoHomeWithChild } = createAction(`${domain}/SELECT_GO_HOME_WITH_CHILD`, (childId) => ({ childId }));
